import React from "react";
import { Alert, Link } from "@mui/material";

export const ArgusSupportBanner = () => {
  return (
    <Alert severity="info" sx={{ marginBottom: 2 }}>
      Having issues with ARGUS file upload? Contact support —{" "}
      <Link
        href="https://www.altusgroup.com/support/#supportoptions"
        target="_blank"
        rel="noopener noreferrer"
      >
        Live Chat / Create Email Case
      </Link>{" "}
      | Telephone: 1-888-692-7487
    </Alert>
  );
};
